module.exports = __webpack_public_path__ + "img/s2P22.84bb124e.png";